<script setup lang="ts">
import type { SupportedLocale } from '@foodlista/shared/i18n/types'
import { LOCALES } from '@foodlista/shared/i18n/constants'

const switchLocalePath = useSwitchLocalePath()
const { locale } = useI18n()

const dropdownItems = computed(() =>
  Object.entries(LOCALES)
    .filter(([_, locale]) => locale.ui)
    .map(([key, locale]) => ({
      label: locale.name,
      href: switchLocalePath(key as SupportedLocale),
    })),
)

function isSupportedLocale(value: string): value is SupportedLocale {
  return Object.hasOwn(LOCALES, value)
}

const selectedLocale = computed(() =>
  LOCALES[isSupportedLocale(locale.value) ? locale.value : 'en'],
)
</script>

<template>
  <UDropdownMenu :items="[dropdownItems]">
    <UButton
      color="neutral" size="sm"
      variant="link"
      icon="i-tabler-language"
      class="p-0"
    >
      {{ selectedLocale.name }}
    </UButton>
  </UDropdownMenu>
</template>
